import axios from "axios";

export function getSessionToken() {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        const [cookieName, cookieValue] = cookie.trim().split('=');
        if (cookieName === 'user_session') {
            return decodeURIComponent(cookieValue);
        }
    }
    return null;
}

export function checkAuth() {
    let token = getSessionToken();
    try {
        // Make a synchronous request to validate the token
        return axios.post('https://apis.topstylemedia.com/index.php/wp-json/jwt-auth/v1/token/validate', {}, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        })
            .then(response => {
                // Check the response status to determine if authentication is successful
                if (response.status === 200) {
                    // Token is valid, authentication successful
                    return true;
                } else {
                    // Token validation failed, authentication failed
                    return false;
                }
            })
            .catch(error => {
                // Error occurred during token validation, authentication failed
                console.error('Error occurred during token validation:', error);
                return false;
            });
    } catch (error) {
        // Error occurred during token validation, authentication failed
        console.error('Error occurred during token validation:', error);
        return false;
    }
}